import React, { useMemo } from 'react';
import { ButtonMenu } from 'components/ButtonMenu/ButtonMenu';
import { Icon } from 'components/Icon/Icon';
import { LayoutDashboardLeftMenuProjectsStyle as S } from './LayoutDashboardLeftMenuProjects.style';
import { Tooltip } from 'components/Tooltip/Tooltip';

export const LayoutDashboardLeftMenuProjects: React.FC = () => {
  const menuItems = useMemo(() => {
    return [
      {
        label: 'Survey',
        url: '/projects?create=survey',
        icon: <Icon icon="surveyLine" size={20} />,
      },
      {
        label: 'Theme Counting',
        url: '/projects?create=import',
        icon: <Icon icon="exploreLine" size={20} />,
      },
      {
        label: 'Summarize',
        icon: <Icon icon="summarizeLine" size={20} />,
        url: '/projects/new?type=summary',
      },
      {
        label: 'Virtual Audience',
        url: '/projects/new?type=va',
        icon: <Icon icon="personaLine" size={20} />,
      },
    ];
  }, []);

  return (
    <S.Container>
      <ButtonMenu
        menuProps={{ appendTo: 'self', popupAlignment: 'right' }}
        buttonProps={{
          label: 'New project',
          severity: 'soft',
          className: 'w-full',
        }}
        className="left-menu-open-element"
        menuItems={menuItems}
      />
      <ButtonMenu
        menuProps={{ appendTo: 'self', popupAlignment: 'right' }}
        buttonIconProps={{
          icon: 'plusLine',
          severity: 'soft',
          size: 'md',
          className: 'layout-dashboard-left-menu-option-new-project',
        }}
        className="left-menu-closed-element"
        menuItems={menuItems}
      />
      <Tooltip
        title="New project"
        placement="right"
        target=".layout-dashboard-left-menu-option-new-project"
      />
    </S.Container>
  );
};
